(function () {
  'use strict';

  function factory(hqTLightingOptions, $state) {
    'ngInject';

    return {
      restart: restart,
    };

    function restart() {
      hqTLightingOptions.reset();
      $state.go('start');
    }
  }

  angular
    .module('hq.tools.lighting')
    .factory('hqTLightingRestart', factory);
}());
